import { AfterViewInit, ElementRef, EventEmitter, SimpleChanges } from "@angular/core";
import { getButtonStyle } from "../../../../shared/utils/get-button-style";
import { TranslateService } from '@ngx-translate/core';
var TestimonialsPanelInfoComponent = /** @class */ (function () {
    function TestimonialsPanelInfoComponent(hostRef, translate) {
        this.hostRef = hostRef;
        this.translate = translate;
        this.readMoreActivated = new EventEmitter();
        this.readMoreButtonText = "Læs mere";
        this.readMoreButtonClass = "bg-navy-button";
        this.readLessButtonText = "Læs mindre";
        this.showQuote = true;
        this.hasReadMoreButton = true;
        this.lastKnownHeight = 0;
    }
    Object.defineProperty(TestimonialsPanelInfoComponent.prototype, "isBigPictures", {
        get: function () {
            return this.item.bigPictures;
        },
        enumerable: true,
        configurable: true
    });
    TestimonialsPanelInfoComponent.prototype.ngOnInit = function () {
        if (this.item.readMoreDescriptionButton && this.item.readMoreDescriptionButton.value && this.item.readMoreDescriptionButton.value.length) {
            this.showQuote = false;
            if (this.item.quote && this.item.quote.value) {
                this.setReadMoreButtonProperties();
            }
        }
    };
    TestimonialsPanelInfoComponent.prototype.ngAfterViewInit = function () {
        this.setCustomThemeProperties(this.item);
    };
    TestimonialsPanelInfoComponent.prototype.ngOnChanges = function (changes) {
        if (changes.forceHideQuoteId && !changes.forceHideQuoteId.firstChange
            && this.item.readMoreDescriptionButton && this.item.readMoreDescriptionButton.value
            && this.item.readMoreDescriptionButton.value.length) {
            this.showQuote = false;
        }
    };
    TestimonialsPanelInfoComponent.prototype.ngOnDestroy = function () {
        if (this.heightCheckInterval) {
            clearInterval(this.heightCheckInterval);
            this.heightCheckInterval = null;
        }
    };
    TestimonialsPanelInfoComponent.prototype.readMoreClick = function () {
        this.readMoreActivated.emit();
        this.showQuote = !this.showQuote;
    };
    TestimonialsPanelInfoComponent.prototype.setReadMoreButtonProperties = function () {
        var _this = this;
        var buttonData = this.item.readMoreDescriptionButton.value[0];
        this.translate.get('testimonialsPanel.Info.ReadMore').subscribe(function (translated) {
            _this.readMoreButtonText = buttonData && buttonData.buttonText && buttonData.buttonText.value
                ? buttonData.buttonText.value
                : translated;
        });
        this.translate.get('testimonialsPanel.Info.ReadLess').subscribe(function (translated) {
            _this.readLessButtonText = buttonData && buttonData.buttonText && buttonData.buttonText.value
                ? buttonData.buttonText.value
                : translated;
        });
        if (!buttonData)
            return;
        if (buttonData.buttonText && buttonData.buttonText.value) {
            this.readMoreButtonText = buttonData.buttonText.value;
        }
        if (buttonData.buttonOffText && buttonData.buttonOffText.value) {
            this.readLessButtonText = buttonData.buttonOffText.value;
        }
        if (buttonData.buttonColor && buttonData.buttonColor.value) {
            var buttonStyle = getButtonStyle(buttonData.buttonColor.value);
            this.readMoreButtonClass = buttonStyle && buttonStyle.buttonClass;
        }
    };
    TestimonialsPanelInfoComponent.prototype.setCustomThemeProperties = function (d) {
        var root = this.hostRef.nativeElement;
        if (d.textColor && d.textColor.value) {
            root.style.setProperty("--testi-panel-info-text-color", d.textColor.value);
        }
        if (d || d.readMoreDescriptionButton || d.readMoreDescriptionButton.value || d.readMoreDescriptionButton.value.length) {
            var buttonData = d.readMoreDescriptionButton.value[0];
            if (!buttonData)
                return;
            if (buttonData.buttonFontWeight && buttonData.buttonFontWeight.value) {
                root.style.setProperty("--readmore-button-font-weight", buttonData.buttonFontWeight.value);
            }
            if (buttonData.buttonTextSize && buttonData.buttonTextSize.value) {
                root.style.setProperty("--readmore-button-text-size", buttonData.buttonTextSize.value);
            }
        }
    };
    return TestimonialsPanelInfoComponent;
}());
export { TestimonialsPanelInfoComponent };
